"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _uiKit = require("@dbi-tools/ui-kit");

var _ = require("./");

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n            ", " {\n              ", "\n            }\n          "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n            ", " {\n              ", "\n            }\n          "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n            ", "\n            ", " {\n              ", "\n            }\n          "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    margin: 0;\n    padding: 0;\n    ", "\n    ", "\n    ", "\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var checkAndGetChildrenStyles = function checkAndGetChildrenStyles() {
  var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var parent = arguments.length > 1 ? arguments[1] : undefined;
  var line = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  if (!parent || !line) return;
  var parentStyles = styles[parent];
  if (!parentStyles) return;
  var child = parentStyles.children ? parentStyles.children.find(function (_ref) {
    var name = _ref.name;
    return name === line;
  }) : '';
  return child && child.style;
};

var _default = function _default(_ref2) {
  var _ref2$styles = _ref2.styles,
      _ref2$styles$desktop = _ref2$styles.desktop,
      desktop = _ref2$styles$desktop === void 0 ? '' : _ref2$styles$desktop,
      _ref2$styles$tablet = _ref2$styles.tablet,
      tablet = _ref2$styles$tablet === void 0 ? '' : _ref2$styles$tablet,
      _ref2$styles$mobile = _ref2$styles.mobile,
      mobile = _ref2$styles$mobile === void 0 ? '' : _ref2$styles$mobile,
      line = _ref2.line,
      _ref2$parent = _ref2.parent,
      parent = _ref2$parent === void 0 ? '' : _ref2$parent;
  var desktopDefaultLine = desktop && desktop[line];
  var tabletDefaultLine = tablet && tablet[line];
  var mobileDefaultLine = mobile && mobile[line];
  var desktopChildLine = parent && checkAndGetChildrenStyles(desktop, parent, line);
  var tabletChildLine = parent && checkAndGetChildrenStyles(tablet, parent, line);
  var mobileChildLine = parent && checkAndGetChildrenStyles(mobile, parent, line);
  var desktopLineStyles = desktopChildLine || desktopDefaultLine;
  var tabletLineStyles = tabletChildLine || tabletDefaultLine;
  var mobileLineStyles = mobileChildLine || mobileDefaultLine;
  return (0, _uiKit.css)(_templateObject(), desktopLineStyles ? (0, _uiKit.css)(_templateObject2(), (0, _.deviceStyles)(desktopLineStyles), _uiKit.GridBreakpointsMediaUp.lg, (0, _.deviceStyles)(desktopLineStyles)) : '', tabletLineStyles ? (0, _uiKit.css)(_templateObject3(), _uiKit.GridBreakpointsMediaDown.lg, (0, _.deviceStyles)(tabletLineStyles)) : '', mobileLineStyles ? (0, _uiKit.css)(_templateObject4(), _uiKit.GridBreakpointsMediaDown.sm, (0, _.deviceStyles)(mobileLineStyles)) : '');
};

exports.default = _default;